exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".calc-text-width{font-size:.8125rem;position:absolute;visibility:hidden;height:auto;width:calc(9rem - 2px);word-break:break-word;line-height:1.5}", ""]);

// exports
